export default "__VITE_ASSET__BKEx_cJj__"